import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: 'auto',
    // width: '70%',
    maxWidth: 1700,
    padding: 24,
    marginTop: '5vh',
    marginBottom: '5vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 12,
    backgroundColor: theme.palette.background.default,
    height: 'fill-available',
    overflowY: 'scroll',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    // backgroundColor: theme.palette.background.default,
    marginTop: 12,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 12
  },
  circularProgressContianer: {
    marginTop: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  collapseContainer: {
    marginTop: theme.spacing(2)
  },
  table: {
    width: 450
  },
  tableHeader: {
    backgroundColor: theme.palette.grey[100]
  },
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 30
  },
  historiesContainer: {
    width: '100%'
  },
  iconWrapper: {
    fontSize: 16,
    marginRight: theme.spacing(2),
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    border: `2px solid ${theme.palette.divider}`
  },
  allocateIcon: {
    '& svg': {
      fontSize: 16
    },
    backgroundColor: '#e8f5e9',
    color: '#4caf50',
    borderColor: '#4caf50'
  }
}))
export default useStyles
